var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformAndSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 22.75C4.94167 22.75 4.5625 22.5875 4.2375 22.2625C3.9125 21.9375 3.75 21.5583 3.75 21.125V4.875C3.75 4.44167 3.9125 4.0625 4.2375 3.7375C4.5625 3.4125 4.94167 3.25 5.375 3.25H18.3208C18.5455 3.25 18.7597 3.29514 18.9633 3.38542C19.1669 3.47569 19.341 3.59306 19.4854 3.7375L22.7625 7.01458C22.9069 7.15903 23.0243 7.33307 23.1146 7.5367C23.2049 7.74033 23.25 7.95448 23.25 8.17917V21.125C23.25 21.5583 23.0875 21.9375 22.7625 22.2625C22.4375 22.5875 22.0583 22.75 21.625 22.75H5.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 16.9178C11.0217 17.0219 10.8744 17.0271 10.7246 16.9335C10.5749 16.8398 10.5 16.6993 10.5 16.512V9.48799C10.5 9.30068 10.5749 9.1602 10.7246 9.06654C10.8744 8.97289 11.0217 8.97809 11.1667 9.08215L16.2971 12.6098C16.4324 12.7034 16.5 12.8335 16.5 13C16.5 13.1665 16.4324 13.2966 16.2971 13.3902L11.1667 16.9178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformAndSaveIcon);
export default __webpack_public_path__ + "static/media/performAndSaveIcon.b3c59f79.svg";
export { ForwardRef as ReactComponent };